<app-page-footer>
  <ng-template #controlBarTemplate>
    <!-- Local reference is needed -->
    <button kendoButton themeColor="secondary" size="large" class="k-mr-10">Abbrechen</button>

    <button class="ms-3" kendoButton themeColor="secondary" size="large">
      <fa-icon class="turquoise k-mr-3" [icon]="faPrint"></fa-icon>
      <span>Druckvorschau</span>
    </button>

    <button
      class="ms-3"
      kendoButton
      themeColor="secondary"
      size="large"
      (click)="createOrUpdateDocument(true)"
    >
      <fa-icon class="turquoise k-mr-3" [icon]="faPrint"></fa-icon>
      <span>Als Template speichern</span>
    </button>

    <button class="ms-3" kendoButton themeColor="secondary" size="large">
      <fa-icon class="turquoise k-mr-3" [icon]="faPrint"></fa-icon>
      <span>Dokument als E-Mail versenden</span>
    </button>

    <button
      class="ms-3"
      kendoButton
      themeColor="secondary"
      size="large"
      [disabled]="invoiceStateService.invoiceId() < 0"
      (click)="createPdf()"
    >
      <fa-icon class="turquoise k-mr-3" [icon]="faPrint"></fa-icon>
      <span>Als PDF herunterladen</span>
    </button>

    <button
      class="ms-3"
      kendoButton
      themeColor="base"
      size="large"
      (click)="createOrUpdateDocument()"
    >
      <span class="custom-symbol save k-mr-3"></span>
      <span>
        {{ invoiceStateService.invoiceId() < 0 ? "Speichern" : "Aktualisieren" }}
      </span>
    </button>
  </ng-template>
</app-page-footer>
